import React from "react";

export const GoldDivider = ({ className = "" }) => (
    <div className={`relative flex items-center justify-center ${className}`} aria-hidden>
        <div className="flex-1 h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" />
        <div className="mx-4 flex items-center gap-3">
            <span className="w-1.5 h-1.5 bg-brand-gold rotate-45" />
            <span className="w-2.5 h-2.5 border border-brand-gold rotate-45" />
            <span className="w-1.5 h-1.5 bg-brand-gold rotate-45" />
        </div>
        <div className="flex-1 h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" />
    </div>
);

export default GoldDivider;
